import { RiArrowDropDownLine } from "react-icons/ri";
import { Typography } from "components";
import "./style.scss";

const DateCTA = ({ onClick }) => {
  return (
    <div className="set-date-cta cursor-pointer" onClick={onClick}>
      <Typography state="primary" variant="caption0">
        Set Date
        <RiArrowDropDownLine fontSize="20px" style={{ marginTop: "-1px" }} />
      </Typography>
    </div>
  );
};

export default DateCTA;
